import { render, staticRenderFns } from "./report-history-container.vue?vue&type=template&id=5f2d7102&scoped=true"
import script from "./report-history-container.vue?vue&type=script&lang=ts"
export * from "./report-history-container.vue?vue&type=script&lang=ts"
import style0 from "./report-history-container.vue?vue&type=style&index=0&id=5f2d7102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d7102",
  null
  
)

export default component.exports